import React from 'react';

import { Newsletter } from '../newsletter';
import { ContentIntro } from '../content-intro';
import { ContentHead } from '../content-head';
import { NewsList } from '../news-list';
import { ContentColumns } from '../content-columns';
import { TeamSection } from '../team-section';
import { FestivalTwoColumns } from '../festival-two-colums';
import { EmbeddedVideo } from '../embedded-video';
import { Gallery } from '../content-gallery';
import { PartnerGroup } from '../partners';
import { Parcours } from '../parcours';
import { ModuleIframe } from '../iframe';

export class Director extends React.Component {
  render = () => (
    <>
      { this.props.modules.map(module => {
        if (module.type === 'moduleIntro')          return <ContentIntro {...module} key={module.id} />;
        if (module.type === 'moduleParcours')       return <Parcours {...module} key={module.id} />;
        if (module.type === 'moduleNewsletter')     return <Newsletter {...module} key={module.id} />;
        if (module.type === 'moduleTeamMembers')    return <TeamSection {...module} key={module.id} />;
        if (module.type === 'moduleTextIn2Columns') return <ContentColumns {...module} key={module.id} />;
        if (module.type === 'moduleEmbeddedVideo')  return <EmbeddedVideo {...module} key={module.id}/>;
        if (module.type === 'moduleIframe')         return <ModuleIframe {...module} key={module.id}/>;
        if (module.type === 'moduleImageGallery')   return <Gallery {...module} key={module.id} />;
        if (module.type === 'patnerGroup')          return <PartnerGroup {...module} key={module.id} />;
        if (module.type === 'moduleFestivalBlocksTwoColumns') return <FestivalTwoColumns {...module} key={module.id} />;        
        
        return <React.Fragment />;
      })}
    </>
  )
}
